import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';
import { fetchWithFallback, API_BASE } from '../../services/apiClient';
// Mapa mínimo para fallback de bandeiras quando a API não fornece foto
const nameToFlag = {
  'portugal': 'pt',
  'brazil': 'br', 'brasil': 'br',
  'spain': 'es', 'espanha': 'es',
  'france': 'fr', 'frança': 'fr',
  'united states': 'us', 'estados unidos': 'us', 'eua': 'us', 'usa': 'us',
  'italy': 'it', 'itália': 'it',
  'germany': 'de', 'alemanha': 'de'
};

const PopularDestinations = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  const normalize = (s='') => s.toString().normalize('NFD').replace(/\p{Diacritic}/gu,'').toLowerCase().trim();

  // Exibir apenas os 5 primeiros países ativos vindos da API

  useEffect(() => {
    const fetchCountries = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('auth_token');
        const baseHeaders = token
          ? { headers: { 'Authorization': `Bearer ${token}`, 'accept': 'application/json' } }
          : { headers: { 'accept': 'application/json' } };
        const publicHeaders = { headers: { 'accept': 'application/json' } };

        const endpoints = ['/pais', '/api/pais', '/paises', '/api/paises', '/countries', '/api/countries'];
        let res = null;
        let data = null;
        for (let i = 0; i < endpoints.length; i++) {
          try {
            res = await fetchWithFallback(endpoints[i], baseHeaders);
            if (!res.ok && token) {
              res = await fetchWithFallback(endpoints[i], publicHeaders);
            }
            if (res.ok) {
              data = await res.json();
              break;
            }
          } catch (_) { /* tenta próximo */ }
        }
        if (!data) data = [];
        const ativos = Array.isArray(data) ? data.filter(p => p.ativoPAIS === 1) : [];
        setCountries(ativos.slice(0, 5));
      } catch (_) {
        setCountries([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        }
      },
      {
        threshold: 0.2
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section className="popular-destinations" ref={sectionRef}>
      <div className="destinations-content">
        <h2>{t('popularDestinations.title')}</h2>
        <p>{t('popularDestinations.subtitle')}</p>
        <div className="destinations-grid">
          {loading && <div style={{padding:16}}>{t('common.loading')}</div>}
          {!loading && countries.length === 0 && <div style={{padding:16}}>{t('popularDestinations.noCountries')}</div>}
          {!loading && countries.map((pais, index) => {
            const nome = pais.nomePAIS || '';
            // Preferir foto da API; se relativa, prefixar com API_BASE e aplicar versionamento
            let foto = '';
            const raw = pais.fotoPAIS && String(pais.fotoPAIS).trim();
            if (raw) {
              if (/^https?:\/\//i.test(raw)) {
                foto = raw;
              } else {
                const path = raw.startsWith('/') ? raw : `/${raw}`;
                foto = `${API_BASE}${path}`;
              }
              // Cache-busting: usa versão do backend quando disponível; caso contrário, renova a cada minuto
              let version = pais.fotoVersao || pais.updatedAt || pais.atualizadoPAIS || pais.atualizadoemPAIS || pais.dataAtualizacao || '';
              if (!version) version = Math.floor(Date.now() / 60000);
              foto += (foto.includes('?') ? '&' : '?') + 'v=' + encodeURIComponent(version);
            } else {
              const code = nameToFlag[normalize(nome)] || pais.slugPAIS || '';
              foto = code ? `/flags/${code}.png` : '/flags/pt.png';
            }
            return (
              <Link
                key={pais.codigoPAIS || nome || index}
                to={`/search-results?country=${encodeURIComponent(nome)}`}
                className="destination-card"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                <div className="destination-image">
                  <img src={foto} alt={nome} />
                  <div className="destination-overlay"></div>
                </div>
                <h3>{nome}</h3>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PopularDestinations; 